import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import EmptyWalletSvg from "@/assets/svg/EmptyWalletSvg";
import { styles } from "../stylesSidebar";
import ArrowForwardIosSvg from "@/assets/svg/ArrowForwardIosSvg";
import { Button, Link } from "@mui/material";
import { useEffect, useRef, useState } from "react";
// import ConnectWithEmail from "@/components/UI/modal/Wallet/ConnectWithEmail";
import ForgotPassword from "@/components/UI/modal/Wallet/ForgotPassword";
// import BuyModal from "@/components/UI/modal/Wallet/ModalInWalletPage/BuyModal";
import { useNavigate } from "react-router-dom";
// import { useGetWalletStatusQuery } from "@/store/api/walletApi";
import { useGetWalletBalanceQuery, useConvertCryptoQuery } from "@/store/api/walletApi";
// import CreateWallet from "@/components/UI/modal/Wallet/CreateWallet";
import CustomToast from "@/components/UI/CustomToast/CustomToast";
import CustomLoader from "@/components/UI/CustomLoader/CustomLoader";
// import LogoutSvg from "@/assets/svg/LogoutSvg";
// import LogoutWalletModal from "@/components/UI/modal/Wallet/ModalInWalletPage/LogoutWalletModal";
import RefreshSvg from "@/assets/svg/RefreshSvg";
import { Howl } from "howler";
import coinSoundFile from "@/assets/sounds/coin.mp3";
import theme from "@/theme";
// import WalletAuthModal from "@/components/UI/modal/Wallet/WalletAuthModal/WalletAuthModal";
import ArrowDeposit from "@/assets/svg/ArrowDeposit";
import ArrowWithdraw from "@/assets/svg/ArrowWithdraw";
import WithdrawModal from "@/components/UI/modal/Wallet/ModalInWalletPage/WithdrawModal";
import DepositModal from "@/components/UI/modal/Wallet/ModalInWalletPage/DepositModal";
import CoinBurst from "./CoinBurst";
import { getToken } from "@/helpers/cookiesHelper";
import { useNotifications } from "@/hooks/useNotifications";
import { formatMoney } from "@/helpers/formatMoney";

const REWARD_COINS: Record<string, number> = { LIKE: 1, ZAP: 3, PURCHASE: 6, SYSTEM: 6 };

const Wallet = () => {
  const [toast, setToast] = useState<{ message: string; success?: boolean } | null>(null);
  const [modal, setModal] = useState<"wallet" | "email" | "forgot" | "create" | null>(null);
  const [showReceiveModal, setShowReceiveModal] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);
  // const [showBuyModal, setShowBuyModal] = useState(false);
  const [prevBalance, setPrevBalance] = useState<number | null>(null);
  const [coinTrigger, setCoinTrigger] = useState(0);
  const [coinAmount, setCoinAmount] = useState<number | undefined>(undefined);
  const [coinCount, setCoinCount] = useState(6);
  // const location = useLocation();
  const nav = useNavigate();
  // const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [manualRefresh, setManualRefresh] = useState(false);

  const coinSound = useRef(
    new Howl({
      src: [coinSoundFile],
      volume: 0.8,
    })
  );

  const token = getToken();

  const requireAuth = (action: () => void) => () => {
    if (!token) {
      nav("/login");
      return;
    }
    action();
  };

  const actionButtons = [
    {
      label: "Deposit",
      icon: <ArrowDeposit />,
      onClick: requireAuth(() => setShowReceiveModal(true)),
    },
    {
      label: "Withdraw",
      icon: <ArrowWithdraw />,
      onClick: requireAuth(() => setShowSendModal(true)),
    },
  ];
  const { last } = useNotifications(token as string);
  const lastRewardUid = useRef<string | null>(null);

  const {
    data: walletBalanceData,
    isLoading: isBalanceLoading,
    // isError: isBalanceError,
    refetch: refetchBalance,
    isFetching,
  } = useGetWalletBalanceQuery(undefined, { refetchOnMountOrArgChange: true, skip: !token });

  useEffect(() => {
    if (!last?.uid || last.uid === lastRewardUid.current) return;
    if (last.type === "PURCHASE" && !last.sender) return;
    if (last.type === "SYSTEM" && last.data?.amount == null) return;
    if (last.data?.direction === "debit") return;
    const coins = REWARD_COINS[last.type as string];
    if (!coins) return;

    lastRewardUid.current = last.uid;
    const raw = last.data?.amount ?? last.data?.satsAmount;
    const amt = typeof raw === "string" ? Number(raw) : raw;
    setCoinAmount(typeof amt === "number" && !Number.isNaN(amt) ? amt : undefined);
    setCoinCount(coins);
    setCoinTrigger((t) => t + 1);
    coinSound.current.play();

    const id = setTimeout(() => refetchBalance(), 1300);
    return () => clearTimeout(id);
  }, [last]);
  // const [logoutFromWallet] = useLogoutFromWalletMutation();
  // const {
  //   data: walletStatus,
  //   isLoading,
  //   isError,
  //   refetch: walletStatusRefetch,
  // } = useGetWalletStatusQuery();
  // const isWalletConnected = walletStatus?.connected;
  // useEffect(() => {
  //   if (!isLoading && walletStatus?.connected === false && location.pathname === "/wallet") {
  //     nav("/", { replace: true });
  //   }
  // }, [isLoading, walletStatus, location.pathname, nav]);

  useEffect(() => {
    if (manualRefresh && !isFetching && !isBalanceLoading && walletBalanceData?.balance != null) {
      const newBalance = walletBalanceData.balance;

      if (prevBalance !== null && newBalance > prevBalance) {
        coinSound.current.play();
        setCoinAmount(newBalance - prevBalance);
        setCoinCount(6);
        setCoinTrigger((t) => t + 1);
      }

      setPrevBalance(newBalance);
      setManualRefresh(false);
    }
  }, [manualRefresh, isFetching, isBalanceLoading, walletBalanceData?.balance]);

  // const shouldShowConnect =
  //   (!isError || !isBalanceError || walletStatus?.connected === false) && isWalletConnected;

  // const handleLogout = async () => {
  //   try {
  //     const res = await logoutFromWallet().unwrap();
  //     setToast({ message: res.message, success: true });
  //     setShowLogoutModal(false);
  //     walletStatusRefetch();
  //     nav("/", { replace: true });
  //   } catch (error: any) {
  //     setToast({
  //       message: error?.data?.message || "Failed to logout from wallet",
  //       success: false,
  //     });
  //   }
  // };

  const {
    data: conversionData,
    isLoading: isConversionLoading,
    isFetching: isConversionFetching,
  } = useConvertCryptoQuery(
    {
      from: "USD",
      to: "USDC",
      amount: walletBalanceData?.balance ?? 0,
    },
    {
      skip: walletBalanceData?.balance == null,
    }
  );

  const convertedUsdc = conversionData?.result;

  const isLoadingWallet = !token || walletBalanceData;

  return (
    <Box sx={styles.walletWrapper}>
      {toast && (
        <CustomToast
          message={toast.message}
          success={toast.success}
          onClose={() => setToast(null)}
        />
      )}
      {/* <LogoutWalletModal
        open={showLogoutModal}
        handleClose={() => setShowLogoutModal(false)}
        onLogout={handleLogout}
      /> */}
      {/* {modal === "wallet" && (
        <ConnectWallet
          onClose={() => setModal(null)}
          onEmailClick={() => setModal("email")}
          onSignupClick={() => setModal("create")}
        />
      )} */}
      {/* <WalletAuthModal
        open={modal === "wallet"}
        onClose={() => setModal(null)}
        walletStatusRefetch={walletStatusRefetch}
        setToast={setToast}
      /> */}
      {/* {modal === "create" && (
        <Box onClick={(e) => e.stopPropagation()}>
          <CreateWallet
            onBack={() => setModal("wallet")}
            onClose={() => setModal(null)}
            walletStatusRefetch={walletStatusRefetch}
            setToast={setToast}
          />
        </Box>
      )} */}

      {/* {modal === "email" && (
        <Box sx={styles.modalOverlay} onClick={() => setModal(null)}>
          <Box onClick={(e) => e.stopPropagation()}>
            <ConnectWithEmail
              onForgotPassword={() => setModal("forgot")}
              onBack={() => setModal("wallet")}
              onClose={() => setModal(null)}
              walletStatusRefetch={walletStatusRefetch}
            />
          </Box>
        </Box>
      )} */}

      {modal === "forgot" && (
        <Box sx={styles.modalOverlay} onClick={() => setModal(null)}>
          <Box onClick={(e) => e.stopPropagation()}>
            <ForgotPassword onBack={() => setModal("email")} />
          </Box>
        </Box>
      )}

      {showReceiveModal && <DepositModal onClose={() => setShowReceiveModal(false)} />}

      {showSendModal && (
        <WithdrawModal
          onClose={() => setShowSendModal(false)}
          maxAvailable={walletBalanceData?.balance ?? 0}
        />
      )}

      {/* {showBuyModal && <BuyModal onClose={() => setShowBuyModal(false)} />} */}

      {
        !isLoadingWallet ? (
          <Box
            sx={{
              ...styles.walletWrapper,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "182px",
            }}
          >
            <CustomLoader />
          </Box>
        ) : (
          <Box sx={styles.balanceCard}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                height: "24px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  height: "24px",
                  cursor: "pointer",
                  textDecoration: "none",
                }}
                component={Link}
                href="https://app.tryspeed.com/dashboard"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Box
                  sx={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "4px",
                    backgroundColor: theme.palette.custom.mainBlue,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    "& path": { stroke: "#FFFFFF" },
                  }}
                >
                  <EmptyWalletSvg width={16} height={16} />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: "14px",
                      lineHeight: "22px",
                      letterSpacing: "-0.5px",
                      color: "#101828",
                    }}
                  >
                    Wethemrkt
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "22px",
                      letterSpacing: "-0.15px",
                      color: "#99A1AF",
                    }}
                  >
                    Wallet
                  </Typography>
                </Box>
              </Box>

              {/* <Button sx={styles.logoutIcon} onClick={() => setShowLogoutModal(true)}>
              <LogoutSvg />
            </Button> */}
            </Box>

            <Box sx={{ ...styles.balance, position: "relative" }}>
              <CoinBurst trigger={coinTrigger} amount={coinAmount} count={coinCount} />
              <Box sx={styles.balanceNav}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <Typography sx={styles.balanceTitle}>Balance</Typography>
                </Box>
                <Button sx={styles.dropdownIcon} onClick={requireAuth(() => nav("/wallet"))}>
                  <ArrowForwardIosSvg />
                </Button>
              </Box>

              <Box
                sx={{
                  minHeight: "41px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    gap: "8px",
                  }}
                >
                  <Typography sx={styles.balanceAmount}>
                    <Typography
                      component="span"
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontSize: "18px",
                        lineHeight: "18px",
                        letterSpacing: "0%",
                        color: "#000000",
                      }}
                    >
                      $
                    </Typography>
                    {token && isBalanceLoading
                      ? "..."
                      : `${formatMoney(walletBalanceData?.balance ?? 0)} `}
                  </Typography>
                  <Box
                    sx={{
                      width: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: "5px",
                    }}
                  >
                    {token && (isBalanceLoading || isFetching) ? (
                      <CustomLoader size={18} />
                    ) : (
                      <Button
                        onClick={requireAuth(() => refetchBalance())}
                        sx={{
                          minWidth: 0,
                          p: 0,
                          m: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#1976d2",
                        }}
                      >
                        <RefreshSvg
                          width={18}
                          height={18}
                          color={theme.palette.custom.mainBlue}
                          flip="horizontal"
                        />
                      </Button>
                    )}
                  </Box>
                </Box>
                <Typography sx={styles.balanceUsd}>
                  ≈ USDC{" "}
                  {token &&
                  (isBalanceLoading || isConversionLoading || isConversionFetching || convertedUsdc == null)
                    ? "..."
                    : formatMoney(convertedUsdc ?? 0)}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                borderTop: "1px solid #E4E7E9",
                width: "196px",
                height: "46px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 0 0 0",
              }}
            >
              {actionButtons.map(({ label, icon, onClick }) => (
                <Button
                  key={label}
                  onClick={onClick}
                  variant="text"
                  sx={{
                    paddingTop: "4px",
                    minWidth: "94px",
                    height: "36px",
                    borderRadius: "6px",
                    padding: 0,
                    background: "transparent",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    overflow: "visible",
                    gap: "2px",

                    textTransform: "none",
                  }}
                >
                  {/* ICON */}
                  <Box
                    sx={{
                      minWidth: "16px",
                      height: "16px",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                  >
                    {icon}
                  </Box>

                  {/* TEXT */}
                  <Box
                    sx={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: "10px",
                      lineHeight: "10px",
                      letterSpacing: "-0.01em",
                      color: "#000000",
                    }}
                  >
                    {label}
                  </Box>
                </Button>
              ))}
            </Box>
          </Box>
        )
        // :
        // (
        //   <Box sx={styles.card}>
        //     <Box
        //       sx={styles.header}
        //       component={Link}
        //       href="https://app.tryspeed.com/dashboard"
        //       target="_blank"
        //       rel="noopener noreferrer"
        //     >
        //       <LogoBlueSvg width={127} height={23} />
        //     </Box>
        //     {/* <Button
        //       variant="contained"
        //       disableElevation
        //       sx={styles.button}
        //       onClick={() => setModal("wallet")}
        //     >
        //       Connect wallet
        //     </Button> */}
        //   </Box>
        // )
      }
    </Box>
  );
};

export default Wallet;
